<app-top-menu-two *ngIf="this.showTopMenu"></app-top-menu-two>

<!--Nav Top-->
<app-nav-top title="Detalhes do pedido" (back)="goback()"></app-nav-top>

<div style="max-width: 800px; margin: 0 auto 60px auto; padding-bottom: 60px;">
  <ng-container *ngIf="this.order && this.company">

    <!--Header do pedido-->
    <div class="order-details-header">
      <div class="order-details-header__content">
        <div>
          <span class="order-number">Pedido #{{ this.numberOrder }}</span>
          <span class="order-date-time">Em {{this.dateOrder}}</span>
        </div>
        <!--Status dos pedidos-->
        <div [ngSwitch]="order.orderStatus">
          <ng-container *ngSwitchCase="1">
            <div class="button-status" *ngIf="order.scheduled && !order.production" style="background-color: #DAA520; border-radius: 5px;">
              <span class="status-order">Agendado</span>
            </div>
            <div class="button-status" *ngIf="!order.scheduled || order.production" style="background-color: #FF8C00; border-radius: 5px;">
              <span class="status-order">Aguardando confirmação</span>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="2">
              <div class="button-status" *ngIf="order.scheduled && !order.production" style="background-color: #DAA520; border-radius: 5px;">
                <span class="status-order">Agendado</span>
              </div>
              <div class="button-status" *ngIf="!order.scheduled || order.production" style="background-color: #1A73E8; border-radius: 5px;">
                <span class="status-order">Em preparo</span>
              </div>
          </ng-container>

          <div class="button-status" *ngSwitchCase="3" style="background-color: #28A745; border-radius: 5px;">
            <span class="status-order">Pronto</span>
          </div>
          <div class="button-status" *ngSwitchCase="4" style="background-color: #28A745; border-radius: 5px;">
            <span class="status-order">A caminho</span>
          </div>
          <div class="button-status" *ngSwitchCase="5" style="background-color: #a9a9a9; border-radius: 5px; border: 1px solid #a1a1a1;">
            <span class="status-order">Finalizado</span>
          </div>
          <div class="button-status" *ngSwitchCase="0" style="background-color: #d70505; border-radius: 5px;">
            <span class="status-order">Cancelado</span>
          </div>
          <div class="button-status" *ngSwitchCase="9" style="background-color: #E65100; border-radius: 5px;">
            <span class="status-order">Aguardando pagamento</span>
          </div>
          <div class="button-status" *ngSwitchCase="10" style="background-color: #d70505; border-radius: 5px;">
            <span class="status-order">Cancelado/Negado</span>
          </div>
          <div class="button-status" *ngSwitchCase="11" style="background-color: #6A1B9A; border-radius: 5px;">
            <span class="status-order">Aguardando reembolso</span>
          </div>
          <div class="button-status" *ngSwitchCase="12" style="background-color: #4527A0; border-radius: 5px;">
            <span class="status-order">Reembolso concluído</span>
          </div>
        </div>
      </div>
    </div>


    <!-- #region Tempo de preparo-->

      <!--Se for 2 é pedido com as propriedades de agendamento-->
      <ng-container *ngIf="shouldShowTimeAwait(order)">
        <app-time-await
          [typeOrder]="order.orderType"
          [visualization]="order.scheduled ? 2 : 1"
          [scheduleStart]="order.scheduled ? order.scheduleStart : ''"
          [scheduleEnd]="order.scheduled ? order.scheduleEnd : ''"
          [createdAtOrder]="!order.scheduled ? order.createdAt : ''">
        </app-time-await>
      </ng-container>

    <!--#endregion-->

    <!--#region Contador cancelamento-->

      <ng-container *ngIf="shouldShowCounter(order)">
        <app-counter-cancelled *ngIf="order.onlinePay === 0 && company.configs.autoCancel === 1"
          [createdAtOrder]="order.scheduled ? order.scheduledReceipt : order.createdAt"
          [id_order]="order.id_order"
          [id_company]="id_company">
        </app-counter-cancelled>
      </ng-container>
    
    <!--#endregion-->

    <!--Tempo de cancelamento-->
    <!-- <ng-container *ngIf="order.orderStatus == 1 && !order.scheduled">
      <app-counter-cancelled *ngIf="order.onlinePay == 0 && this.company.configs.autoCancel == 1" [createdAtOrder]="order.createdAt" [id_order]="order.id_order" [id_company]="this.id_company"></app-counter-cancelled>
    </ng-container>

    <ng-container *ngIf="order.orderStatus == 1 && order.scheduled && order.production">
      <app-counter-cancelled *ngIf="order.onlinePay == 0 && this.company.configs.autoCancel == 1" [createdAtOrder]="order.scheduledReceipt" [id_order]="order.id_order" [id_company]="this.id_company"></app-counter-cancelled>
    </ng-container> -->


    <!--Tempo de preparo-->
    <!-- <ng-container *ngIf="order.scheduled">
      <app-time-await [typeOrder]="order.orderType" [visualization]="2" [scheduleStart]="order.scheduleStart" [scheduleEnd]="order.scheduleEnd" *ngIf="shouldShowTimeAwait(order)"></app-time-await>
    </ng-container>
    
    <ng-container *ngIf="!order.scheduled">
      <app-time-await [typeOrder]="order.orderType" [visualization]="1" [createdAtOrder]="order.createdAt" *ngIf="shouldShowTimeAwait(order)"></app-time-await>
    </ng-container> -->

    
    <!--Barra de progresso-->
    <div style="padding-left: 1rem; padding-right: 1rem;">
      <app-progress-bar [order]="order" *ngIf="this.order.orderStatus != 5 && this.order.orderStatus != 0 && this.order.orderStatus != 10 && this.order.orderStatus != 11 && this.order.orderStatus != 12"></app-progress-bar>
    </div>

    <!--Input e Tempo Pix-->
    <app-input-copy-pix *ngIf="order.orderStatus == 9 && order.paymentForm[0].paymentForm == 0" [valueKey]="this.order.paymentForm[0].pixCode" [dateTimeTransation]="this.order.createdAt"></app-input-copy-pix>

    <!--Cartão-->
    <div class="counter-card-payment" *ngIf="order.orderStatus == 9 && (order.paymentForm[0].paymentForm == 7 || order.paymentForm[0].paymentForm == 9) && !order.paymentExpired">
      <app-counter-timing [dateTimeTransaction]="order.createdAt" [fontSize]="'20px'" [minutes]="10" (finalizionCounter)="order.paymentExpired = true"></app-counter-timing>
      <span class="text-information">Finalize o pagamento dentro do tempo limite para evitar o cancelamento do pedido.</span>
    </div>

    <div class="button-detail-order" *ngIf="order.onlinePay == 1 && order.orderStatus == 9 && (order.paymentForm[0].paymentForm == 7 || order.paymentForm[0].paymentForm == 9) && order.paymentForm[0].linkCheckout != ''">
      <button (click)="finalizarPagamento(order)" style="background-color: var(--primary-color); color: white;">Finalizar pagamento</button>
    </div>

    <!--Eventos-->
    <app-history-events [order]="order"></app-history-events>

    <!-- Banner Cashback -->
    <div class="cashback-wrapper" *ngIf="this.order.cashbackIn != '0.00' && (this.order.orderStatus != 0 && this.order.orderStatus != 10 && this.order.orderStatus != 11 && this.order.orderStatus != 12)">
      <div class="cashback-card">
        <div class="cashback-icon-box">
          <div class="icon-wallet" style="color: green;"></div>
        </div>
        <div class="cashback-info">
          <span class="cashback-label">Você ganhou cashback!</span>
          <span class="cashback-value">{{ this.order.cashbackIn | currency:'BRL' }}</span>
        </div>
        <div class="cashback-tag" (click)="goToCashback()" style="cursor: pointer;">
          <span class="tag-text">Ver saldo</span>
          <div class="icon-chevron-right" style="font-size: 10px; margin-top: 1px;"></div>
        </div>
      </div>
    </div>

    <!--Pedido-->
    <div class="box">
      <div class="box-tittle">
        <div>Pedido</div>
      </div>
      <div class="box-body">
        <div class="body-order">
          <div class="body-order__order" *ngFor="let item of items.items; let i = index">
            <div class="d-flex" style="font-size: 13px; gap: 5px; justify-content: space-between; margin-bottom: 10px;">
              <div class="d-flex">
                <img class="img-item" [src]="item.product.image_prod" />
                <div class="d-flex" style="flex-direction: column;">
                  <div class="d-flex">
                    <div style="margin-right: 3px;">{{ item.quantity }}x</div>
                    <span>{{ item.product.name }}</span>
                  </div>

                  <div style="padding-left: 10px;">
                    <div>
                      <ng-container *ngFor="let additionais of item.subitems">
                        <ng-container *ngIf="additionais.product.flavor == 1">
                          <ng-container *ngIf="item.subitems.length == 1">
                            <div style="color: gray;">
                              <span style="font-size: 12px;">1x</span><span style="font-size: 11px;"> {{ additionais.product.name }}</span>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="item.subitems.length != 1">
                            <div style="color: gray;">
                              <span style="font-size: 12px;">{{ additionais.quantitySub }}/{{ item.flavorsCount }}</span><span style="font-size: 11px;"> {{ additionais.product.name }}</span>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngFor="let additionais of item.subitems">
                        <ng-container *ngIf="additionais.product.flavor == 0">
                          <div style="color: gray;">
                            <span style="font-size: 12px;">{{ additionais.quantitySub }}x</span><span style="font-size: 11px;"> {{ additionais.product.name }}</span>
                          </div>
                        </ng-container>
                      </ng-container>

                    </div>
                  </div>
                  <span *ngIf="item.observations != ''" style="color: gray; max-width: 200px; word-wrap: break-word;">Obs: {{ item.observations }}</span>
                </div>
              </div>

              <div>
                <span class="price-item">{{ item.totalPrice | currency:'BRL' }}</span>
              </div>

            </div>
          </div>
          <span style="color: gray; font-size: 14px; word-wrap: break-word; width: 100%;" *ngIf="this.order.orderObservation != ''">Obs: {{ this.order.orderObservation }}</span>
        </div>
      </div>
    </div>

    <!--Endereço de entrega-->
    <div class="box" *ngIf="this.order.orderType == 5">
      <div class="box-tittle">
        <div>Endereço de entrega</div>
      </div>
      <div class="box-body">
        <div class="body-order">
          <div class="body-order__order">
            <div class="address_content">
              <div>{{this.addressDelivery.street}}, {{this.addressDelivery.number}}</div>
              <div>{{ this.addressDelivery.neighborhood }}, {{ this.addressDelivery.city }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Tipo do pedido-->
    <div class="box" *ngIf="this.order.orderType == 3 || this.order.orderType == 2">
      <div class="box-tittle">
        <div>Tipo do pedido</div>
      </div>
      <div class="box-body">
        <div class="body-order">
            <div class="content-receipt">
              <div class="icon-local"><i class="icon-route" style="font-size: 20px; color: var(--primary-color);"></i></div>
              <div style="font-size: 14px; color: #575757; padding-left: 10px;" *ngIf="this.order.orderType == 3">Retirar no local</div>
              <div style="font-size: 14px; color: #575757; padding-left: 10px;" *ngIf="this.order.orderType == 2">Retirar no balcão</div>
            </div>
        </div>
      </div>
    </div>

    <!--Localização-->
    <div class="box" *ngIf="this.order.placeName != ''">
      <div class="box-tittle">
        <div>Localização</div>
      </div>
      <div class="box-body">
        <div class="body-order">
            <div class="content-receipt">
              <div class="icon-local"><i class="icon-map-pin-house" style="font-size: 20px; color: var(--primary-color);"></i></div>
              <div style="font-size: 14px; color: #575757; padding-left: 10px;">{{ this.order.placeName }}</div>
            </div>
        </div>
      </div>
    </div>

    <!--Tipo do pagamento-->
    <div class="box">
      <div class="box-tittle">
        <div>Tipo de pagamento</div>
      </div>
      <div class="box-body">
        <div class="form-payment__body">
          <div class="form-payment-option">
            <div style="display: flex; align-items: center;" *ngIf="this.order.onlinePay == 0 && this.order.id_company != 'f33fcb89-4d42-4745-b090-212cd6f359bd'">
              <div class="form-payment-option__icon">
                <i class="icon-truck" style="font-size: 20px;" *ngIf="this.order.orderType == 5"></i>
                <!-- <img src="assets/icons/counter.png" style="width: 22px;" *ngIf="this.order.orderType == 2 || this.order.orderType == 3"/> -->
                <i class="icon-store" style="font-size: 20px;" *ngIf="this.order.orderType == 2 || this.order.orderType == 3"></i>
              </div>
              <div class="form-payment-option__tittle" style="font-size: 14px; color: #575757;" *ngIf="this.order.orderType == 5">
                Pagamento na entrega
              </div>
              <div class="form-payment-option__tittle" style="font-size: 14px; color: #575757;" *ngIf="this.order.orderType == 2 || this.order.orderType == 3">
                Pagamento no balcão
              </div>
            </div>
            <div style="display: flex; align-items: center;" *ngIf="this.order.paymentForm[0].onlinePay == 1 || this.order.id_company == 'f33fcb89-4d42-4745-b090-212cd6f359bd'">
              <div class="form-payment-option__icon">
                <i class="icon-smartphone" style="font-size: 20px;"></i>
              </div>
              <div class="form-payment-option__tittle" style="font-size: 14px; color: #575757;">
                Pagamento no app
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Forma de pagamento-->
    <div class="box">
      <div class="box-tittle">
        <div>Forma de pagamento</div>
      </div>
      <div class="box-body">
        <div class="form-payment__body">
          <ng-container *ngFor="let form of this.order.paymentForm">
            <div class="form-payment-option" [ngSwitch]="form.paymentForm">
              <div style="display: flex; flex-direction: column;">
                <div style="display: flex; align-items: center;">
                  <div class="form-payment-option__icon" [ngSwitch]="form.icon">
                    <i *ngSwitchCase="1"><img src="../../../../assets/icons/method-payment/dinheiro.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="2"><img src="../../../../assets/icons/method-payment/generic-card-1.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="3"><img src="../../../../assets/icons/method-payment/generic-card-2.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="4"><img src="../../../../assets/icons/method-payment/mastercard-card.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="5"><img src="../../../../assets/icons/method-payment/visa-card.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="6"><img src="../../../../assets/icons/method-payment/pix.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="7"><img src="../../../../assets/icons/method-payment/american-express.png"  style="width: 25px;"/></i>
                    <i *ngSwitchDefault><img src="../../../../assets/icons/method-payment/generic-card-1.png"  style="width: 25px;"/></i>
                  </div>
                  <div class="form-payment-option__tittle" style="font-size: 14px; color: #575757;">
                    {{form.paymentName}}
                  </div>
                </div>
                <div class="obs_ChangeFor" *ngIf="this.order.paymentForm[0].changeFor != '0.00'">*Obs: troco para R${{ this.order.paymentForm[0].changeFor}}</div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="box" *ngIf="this.order.discounts.length > 0">
      <div class="box-tittle">
        <div>Cupom utilizado</div>
      </div>
      <div class="box-body">
        <div class="body-order">
            <div class="content-receipt">
              <div class="icon-local"><img class="img-coupon" src="../../../assets/icons/cupom.png" /></div>
              <div style="font-size: 14px; color: green; padding-left: 10px;">{{ this.order.discounts[0].couponName }}</div>
            </div>
        </div>
      </div>
    </div>


    <!--Informações Totais-->
    <div class="price-total-order">
      <div class="total">
        <div class="summary-total">

          <!--Subtotal-->
          <div class="total-value">
            <div class="total-span">Subtotal</div>
            <div class="total-span">{{ this.subTotalOrder | currency:'BRL' }}</div>
          </div>

          <!--Taxa de entrega-->
          <div class="total-value" *ngIf="this.order.orderType == 5">
            <div class="total-span">Taxa de entrega</div>
            <div class="total-span" *ngIf="this.order.deliveryFee != '0.00'">{{ this.order.deliveryFee | currency:'BRL' }}</div>

            <ng-container *ngIf="!this.order.discounts[0]">
              <div class="total-span" *ngIf="this.order.deliveryFee == '0.00'" style="color: green;">Grátis</div>
            </ng-container>

            <ng-container *ngIf="this.order.discounts[0]">
              <div class="total-span" *ngIf="this.order.deliveryFee == '0.00' && this.order.discounts[0].couponType != 3" style="color: green;">Grátis</div>
              <div class="total-span" *ngIf="this.order.deliveryFee == '0.00' && this.order.discounts[0].couponType == 3">{{ this.order.discounts[0].discountValue | currency:'BRL' }}</div>
            </ng-container>

          </div>

          <!--Taxas e descontos-->
          <ng-container *ngIf="this.order.fees">
            <ng-container *ngIf="this.order.fees.length > 0">
              <div class="total-value" *ngIf="this.order.fees[0].valueFee != '0.00'">
                <div class="total-span" *ngIf="this.order.fees[0].feeType == 1">{{ this.order.fees[0].type == 2 ? 'Taxa adicional' : 'Desconto' }} ( {{ this.order.fees[0].formName }} {{ this.order.fees[0].originalValue | currency:'BRL' }} )</div>
                <div class="total-span" *ngIf="this.order.fees[0].feeType == 2">{{ this.order.fees[0].type == 2 ? 'Taxa adicional' : 'Desconto' }} ( {{ this.order.fees[0].formName }} {{ this.order.fees[0].originalValue }}% )</div>
                <div class="total-span" [ngStyle]="this.order.fees[0].type == 1 ? {'color': 'green'} : {}">{{ this.order.fees[0].valueFee | currency:'BRL' }}</div>
              </div>
            </ng-container>
          </ng-container>

          <!--Cashback-->
          <div class="total-value" *ngIf="this.order.cashbackOut != '0.00' && (this.order.orderStatus != 0 && this.order.orderStatus != 10 && this.order.orderStatus != 11 && this.order.orderStatus != 12)">
            <div class="total-span">Cashback utilizado</div>
            <div class="total-span" style="color: red;">-{{ this.order.cashbackOut | currency:'BRL' }}</div>
          </div>


          <!--Cupom-->
          <ng-container *ngIf="this.discount != 0">
            <div class="total-value" *ngIf="this.order.discounts[0].discountValue != '0'">
              <div class="total-span">Cupom</div>
              <div class="total-span" style="color: green;">-{{ this.order.discounts[0].discountValue | currency:'BRL' }}</div>
            </div>
          </ng-container>

        </div>

        <!--Total-->
        <div class="div-total-value">
          <div class="content-total-value">
            <div>Total</div>
            <div>{{ this.order.orderPrice | currency:'BRL' }}</div>
          </div>
        </div>

      </div>
    </div>

    <!-- <app-feedback></app-feedback> -->
  </ng-container>
</div>
